module.exports = __webpack_public_path__ + "img/pitching1.cfebd243.png";